import React from "react";
import * as http from "./http.ts";

import { useBackendData, useFormState } from "./hooks.ts";

function VolunteerNotesForm({
  wp,
  contact,
  action,
  notes,
  deleteNote,
  updateNote,
  refetchNotes,
}) {
  const [selected, setSelected] = React.useState(null);
  const noteTextInput = React.useRef(null);

  const { value, setValue, error, handleSubmit } = useFormState({
    action,
    handleSubmitted,
  });

  function editNote(note_id, e) {
    e.preventDefault();
    setSelected(note_id);
    setValue({});
  }

  function saveEditedNote(note) {
    updateNote({ ...note, note: noteTextInput.current?.value });
    setSelected(null);
  }

  function setNoteText(e) {
    var text = e.target.value;
    setValue({
      ...value,
      volunteer: contact._id,
      workparty: wp._id,
      note: text,
    });
  }

  function removeNote(note_id, e) {
    e.preventDefault();
    deleteNote(note_id);
  }

  function handleSubmitted(data) {
    refetchNotes();
  }

  return (
    <div>
      <h5>Volunteer Notes</h5>
      <div>
        {Object.values(notes).map((note) =>
          selected != note._id ? (
            <div>
              <h3>
                {note.date} (
                <em>
                  by {note.from.firstname} {note.from.lastname}
                </em>
                )
                <span className="icon-cancel">
                  <a href="#" onClick={removeNote.bind(null, note._id)}>
                    Remove
                  </a>
                </span>{" "}
                <span className="icon-pencil">
                  <a href="#" onClick={editNote.bind(null, note._id)}>
                    Edit
                  </a>
                </span>
              </h3>
              <p>{note.note}</p>
            </div>
          ) : (
            <div>
              <textarea
                ref={noteTextInput}
                id={note._id}
                defaultValue={note.note}
                style={{ width: "100%" }}
              ></textarea>
              <button
                onClick={saveEditedNote.bind(null, note)}
                className="ui small button"
              >
                Edit note
              </button>
            </div>
          ),
        )}
        {selected == null ? (
          <>
            <div style={{ padding: "14.66667px 11px" }}>
              Add volunteer note:
              <textarea
                onChange={setNoteText.bind(null)}
                style={{ width: "100%" }}
              ></textarea>
            </div>
            <button onClick={handleSubmit} className="ui small button">
              Add note
            </button>
          </>
        ) : null}
      </div>
      {error ? (
        <div className="validation-error">
          <div className="container">{error}</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

function VolunteerNotes({ wp, contact }) {
  const [cachebreaker, setCachebreaker] = React.useState(Date.now());
  const data = useBackendData({
    url: `${wp.views.notes}?volunteer=${contact._id}&${cachebreaker}`,
  });
  const refetch = () => setCachebreaker(Date.now());

  function deleteNote(note_id) {
    var remove_url = wp.actions.removenote;
    var contact_id = contact._id;
    http
      .postJson(remove_url, { note_id: note_id, volunteer_id: contact_id })
      .then(() => refetch());
  }

  function updateNote(note) {
    http
      .postJson(wp.actions.editnote, {
        note_id: note._id,
        note: note.note,
        volunteer: note.volunteer,
        workparty: note.work_party,
      })
      .then(() => refetch());
  }

  return data ? (
    <VolunteerNotesForm
      wp={wp}
      contact={contact}
      notes={data}
      action={wp.actions.savenotes}
      deleteNote={deleteNote}
      updateNote={updateNote}
      refetchNotes={refetch}
    />
  ) : (
    <div>Loading...</div>
  );
}

export default VolunteerNotes;
